import { DateTime } from 'luxon';
// gives back scheduleDay data depending on the feature gate "canSeeMultipleShiftSwap"
export var getScheduleDayData = function (_a) {
    var _b, _c;
    var swapSchedule = _a.swapSchedule, canSeeMultipleShiftSwap = _a.canSeeMultipleShiftSwap, swapFromShiftStart = _a.swapFromShiftStart, swapFromDate = _a.swapFromDate;
    if (canSeeMultipleShiftSwap) {
        var swapFromDateFromShiftStart_1 = DateTime.fromISO(swapFromShiftStart).toISODate();
        var swapFromScheduleDay = swapSchedule === null || swapSchedule === void 0 ? void 0 : swapSchedule.scheduleDays.find(function (swapScheduleDay) {
            return swapScheduleDay.timeRange.start === swapFromShiftStart;
        });
        var allScheduleDaysForDay = (swapSchedule === null || swapSchedule === void 0 ? void 0 : swapSchedule.scheduleDays.filter(function (swapScheduleDay) {
            return swapScheduleDay.date === swapFromDateFromShiftStart_1;
        })) || [];
        var swappableDays = (_b = swapFromScheduleDay === null || swapFromScheduleDay === void 0 ? void 0 : swapFromScheduleDay.swappableDays) !== null && _b !== void 0 ? _b : [];
        var noSwapsAvailable = !swappableDays.length;
        return {
            swapFromScheduleDay: swapFromScheduleDay,
            allScheduleDaysForDay: allScheduleDaysForDay,
            swappableDays: swappableDays,
            noSwapsAvailable: noSwapsAvailable
        };
    }
    else {
        var swapFromScheduleDay = swapSchedule === null || swapSchedule === void 0 ? void 0 : swapSchedule.scheduleDays.find(function (swapScheduleDay) { return swapScheduleDay.date === swapFromDate; });
        // allScheduleDaysForDay when feature gate is off is not used. but here for typescript check
        var allScheduleDaysForDay = swapFromScheduleDay
            ? [swapFromScheduleDay]
            : [];
        var swappableDays = (_c = swapFromScheduleDay === null || swapFromScheduleDay === void 0 ? void 0 : swapFromScheduleDay.swappableDays) !== null && _c !== void 0 ? _c : [];
        var noSwapsAvailable = !swappableDays.length;
        return {
            swapFromScheduleDay: swapFromScheduleDay,
            allScheduleDaysForDay: allScheduleDaysForDay,
            swappableDays: swappableDays,
            noSwapsAvailable: noSwapsAvailable
        };
    }
};
